<template>
  <div class="phonesign">
    <div v-show="loading" class="loading">
      <van-loading type="spinner" color="#1989fa" />
    </div>
    <van-nav-bar
      :title="'移动签到'"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
      :right-text="'查看足迹'"
      @click-right="zj"
    >
    </van-nav-bar>
    <div class="phonesignIndexBox">
      <div id="phonesign_container" v-if="map_api_factory == 0"></div>
      <div class="address-p">
        <div class="address">当前位置：{{ address }}</div>

        <!--  -->
        <van-button
          v-if="wt"
          square
          type="info"
          size="small"
          @click="showwt = true"
        >
          微调地点
        </van-button>
      </div>
      <van-button
        square
        type="info"
        size="small"
        @click="test(i)"
        v-for="i in 7"
        :key="i"
        v-show="false"
      >
        <!--
         -->
        test{{ i }}
      </van-button>

     
      <div class="signlist">
        <div class="signbox" v-for="(item, index) in daylist" :key="index">
          <div class="signico"></div>
          <div>
            <div class="sigtime">
              打卡时间：<span>{{ item.hhmm }}</span>
            </div>
            <div class="sigtadd">
              {{ item.signaddr }}
            </div>
          </div>
        </div>
      </div>
       <div v-if="sign_remark_memo" class="sign_remark" :style="{color:sign_remark_fontcolor,fontSize:sign_remark_fontsize+'px'}">{{sign_remark_memo}}</div>
      <div class="content">
        <van-button
          :disabled="!cansign || !address"
          class="check"
          color="linear-gradient(to bottom, #23c1d1, #0a46ee)"
          size="small"
          round
          @click="clickSign(false)"
        >
          考勤<br />签到
        </van-button>
        <van-uploader
          ref="uploader1"
          v-model="fileList"
          max-count="1"
          capture="camera"
          :accept="accept"
          :after-read="afterRead"
          :disabled="!cansign || !address"
          style="display:none"
        >
        </van-uploader>
        <div class="cks2">你刚刚已签到{{ daylist.length }}次</div>
        <div
          class="cks3"
          style="color: red;font-size: 15px;text-align: center;padding: 0 11px;font-weight: bold;"
        >
          {{ tipsWord }}
        </div>
        <div v-if="!cansign" class="cks3">
          <van-icon name="warning" /> 当前位置不在签到范围内
        </div>
      </div>
    </div>
    <!-- 签到详细 -->
    <van-dialog
      :before-close="confirm"
      v-model="showdailog"
      title="签到详细"
      show-cancel-button
      class="signdetail"
    >
      <van-field
        v-model="content"
        rows="3"
        autosize
        v-if="needdailog"
        label="签到描述"
        type="textarea"
        placeholder="请输入签到描述"
      />
      <div class="prjcodebox">
        <van-field
          v-model="prjcode"
          v-if="show_prj_when_sign"
          
          readonly
          label="项目编号"
          placeholder="请输入项目编号"
          right-icon="arrow-down"
          @click="getprjPicker"
        />
        <van-button
        v-if="show_prj_when_sign"
          plain
          type="info"
          icon="list-switch"
          size="small"
          @click="showPrjDetail()"
        ></van-button>
      </div>
      <van-field
        v-model="prjname"
        v-if="show_prj_when_sign"
        readonly
        label="项目名称"
        placeholder="请输入项目名称"
      />
      <div class="btnlist" v-if="btnlist.length > 0">
        <van-button
          v-for="(item, index) in btnlist"
          :key="index"
          :color="item.name == choosbtn ? null:item.btncolor"
          :type="item.name == choosbtn ? 'warning' : 'info'"
          @click="setChoosbtn(item)"
          :size="'small'"
          >{{ item.name }}
          <div v-if="item.time">({{item.time}})</div>
          </van-button
        >
      </div>
      <van-field name="uploader" label="文件上传" v-if="needfile">
        <template #input>
          <van-uploader
            v-model="fileList"
            max-count="1"
            capture="camera"
            :accept="accept"
          />
        </template>
      </van-field>
    </van-dialog>

    <van-popup v-model="showwt" round position="bottom">
      <van-picker
        show-toolbar
        :columns="pois"
        value-key="partname"
        :confirm-button-text="$t('module.confirm')"
        :cancel-button-text="$t('module.cancel')"
        @cancel="showwt = false"
        @confirm="onConfirmwt"
      />
    </van-popup>
    <!-- 不同意面试原因弹窗 -->
    <van-popup v-model="showprjListPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="prjListPick"
        :confirm-button-text="$t('module.confirm')"
        :cancel-button-text="$t('module.cancel')"
        @cancel="showprjListPicker = false"
        @confirm="onConfirmwprjLis"
      />
    </van-popup>
    <van-popup
      v-model="showPrjDetailflag"
      position="right"
      :style="{ width: '100%', height: '100%' }"
      class="PrjDetail"
    >
      <van-nav-bar
        :title="'项目详情'"
        left-arrow
        @click-left="showPrjDetailflag = false"
        :fixed="true"
      >
      </van-nav-bar>
      <div class="phonesignIndexBox">
        <van-collapse v-model="activeNames">
          <van-collapse-item title="基本信息" name="1">
            <van-field
              v-model="prjcode"
              v-if="show_prj_when_sign"
              readonly
              disabled
              label="项目编号"
              placeholder="请输入项目编号"
            />
            <van-field
              v-model="prjname"
              v-if="show_prj_when_sign"
              readonly
              disabled
              label="项目名称"
              placeholder="请输入项目名称"
            />
            <van-field
              v-model="prjmemo"
              rows="3"
              autosize
              readonly
              disabled
              label="项目描述"
              type="textarea"
              placeholder="请输入签到描述"
            />
          </van-collapse-item>
          <van-collapse-item title="项目成员" name="2">
            <table ref="table" class="table">
              <thead>
                <tr>
                  <th v-for="(v, i) in th" :key="i">{{ v }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(e, i) in prj_emplist" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td>{{ e.empname }}</td>
                  <td>{{ e.empcode }}</td>
                  <td>{{ e.deptname }}</td>
                  <td style=" text-align: left;">{{ e.job }}</td>
                </tr>
              </tbody>
            </table>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-popup>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { GetJsSign } from '@api/hp.js'
import { getDdSigurate } from '@api/dingding.js'
import {
  getWxEntConfigInfo,
  getCurDateSignCardList,
  getEmpSignPosition,
  beforeClickPhoneSignInfo,
  beforePostPhoneSignInfo,
  savePhoneSignInfo,
  getEmpMapKeyInfo,
  getSignPrjList
} from '@api/sign.js'
import { GetFilterDropDownList, upLoadFile } from '@api/wx.js'
import { Toast, Notify, Dialog } from 'vant'
import { json } from 'body-parser'
import { parseTime, GetDistance } from '@/utils'
export default {
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      map: null,
      marker: null,
      geocoder: null,
      geolocation: null,
      center: [113.2932, 22.805412], //[0, 0],
      address: '',
      daylist: [],
      loading: true,
      cansign: false, //是否允许点击我要签到
      needdailog: false, //是否需要显示详细内容
      showdailog: false,
      content: '',
      btnlist: [],
      choosbtn: '',
      needfile: true, //是否需要附件
      wt: true, //是否地点微调
      showwt: false, //显示地点微调列表
      posList: [],
      fileList: [],
      pois: [],
      accept: 'image/*', //video/* image/*
      sign_post_info: '', //签到成功提示语，如果未设置或为空表示无需弹窗提醒
      map_key: '', //'25998b3462a186b782bb7cc9aa6c8383',
      map_secret: '', //'8eb80839b1d45a2671066e915ad7d16a',
      winCheckWifi: window.winCheckWifi,
      newSSID: '',
      newBSSID: '',
      tipsWord: '',
      prjcodeindex: null,
      prjcode: '',
      prjname: '',
      prjmemo: '',
      prj_emplist: [],
      show_prj_when_sign: false,
      map_api_factory: 0,
      prjList: [],
      prjListPick: [],
      showprjListPicker: false,
      showPrjDetailflag: false,
      activeNames: ['1', '2'],
      th: ['序号', '姓名', '工号', '部门', '在本项目中承担的工作'],
      sign_remark_memo: '', //签到界面说明文字内容
        sign_remark_fontsize: 0, //字体大小
        sign_remark_fontcolor: '', //字体颜色
    }
  },
  mounted() {
    // 此行代码 不要做任何修改
    window.receiveAppData = this.receiveAppData
    // 此行代码 不要做任何修改
    window.iosReceiveAppData = this.iosReceiveAppData
     if(window.globalurls!=window.location.href){
            location.href = window.location.href
    }else{
        this._getEmpMapKeyInfo()
        this._getCurDateSignCardList()
        this._GetFilterDropDownList()
        this.tipsUserOpenTrueWifi()
    }
  },
  unmounted() {
    this.map?.destroy()
    this.marker?.destroy()
    this.geocoder?.destroy()
  },
  watch: {
    $route: {
      async handler(n) {
        if (n.path == '/phonesign') {
          // 此行代码 不要做任何修改
          window.receiveAppData = this.receiveAppData
          // 此行代码 不要做任何修改
          window.iosReceiveAppData = this.iosReceiveAppData
          this.tipsUserOpenTrueWifi()
        }
        // console.log(n,'fwfewfwe')
      },
      immediate: true
    }
  },
  methods: {
    tipsUserOpenTrueWifi() {
      if (window.winCheckWifi && sessionStorage.getItem('isOpenApp') == 1) {
        beforeClickPhoneSignInfo({
          empid: this.userInfo.empid,
          wifi_name: this.$route.query.ssid || '',
          wifi_ssid: this.$route.query.bssid || '',
          prjcode: this.prjcode
        }).then(res => {
          if (res.data[0].isinfo && !res.data[0].cansave) {
            this.tipsWord = res.data[0].info
            Dialog.alert({
              title: '系统警告！',
              message: res.data[0].info
            }).then(() => {})
          }
        })
      }
    },
    // 此方法名，不要做任何更改，也不要在任何地方使用！！
    async receiveAppData(data) {
      if (data.apptype == 2) {
        this.newSSID = data.ssid
        this.newBSSID = data.bssid
        this._beforePostPhoneSignInfo(null)
      }
    },
    // 此方法名，不要做任何更改，也不要在任何地方使用！！
    async iosReceiveAppData(data) {
      if (data.apptype == 2) {
        this.newSSID = data.ssid
        this.newBSSID = data.bssid
        this._beforePostPhoneSignInfo(null)
      }
    },
    // 获取高德地图key
    _getEmpMapKeyInfo() {
      getEmpMapKeyInfo().then(res => {
        if (window.dev) {
          alert(JSON.stringify(res))
        }
        if (res.data.length > 0) {
          this.map_key = res.data[0].map_key
          this.map_secret = res.data[0].map_secret
        }
        this._getWxEntConfigInfo()
      })
    },
    // 获取签到参数配置
    _getWxEntConfigInfo() {
      getWxEntConfigInfo({ empid: this.userInfo.empid }).then(res => {
        // if (window.dev) {
        //   alert(JSON.stringify(res))
        // }
        this.map_api_factory = res.data[0].map_api_factory || 0
        // 缓存判断为app
        if (sessionStorage.getItem('isOpenApp') == 1 || window.isapp == 1) {
          this.initAMap(2)
        }
        // 微信
        else if (res.data[0].sign_type == 0) this.weixinConfig()
        // 钉钉
        else if (res.data[0].sign_type == 1) {
            this.dingdingConfig()     
        }
        // APP
        else if (res.data[0].sign_type == 2) {
          // this.center = [this.$route.query.lng, this.$route.query.lat]

          this.initAMap(res.data[0].sign_type)
          // this.initAMap(1)
        }
        // this.initAMap()

        this.needdailog = res.data[0].sign_must_select_flag
        this.needfile = res.data[0].sign_must_uploadfile
        this.wt = res.data[0].sign_can_adjust_position
        this.sign_post_info = res.data[0].sign_post_info
        this.show_prj_when_sign = res.data[0].show_prj_when_sign || false

        this.accept = res.data[0].sign_filetype ? 'video/*' : 'image/*'
         this.sign_remark_memo= res.data[0].sign_remark_memo
         this.sign_remark_fontsize= res.data[0].sign_remark_fontsize
         this.sign_remark_fontcolor= this.colorToHex(res.data[0].sign_remark_fontcolor)
      })
    },
    // 十进制数字转HEX
    colorToHex(color) {
      if (color || color == 0) {
        if (typeof color != "string") {
          color = "#" + Math.abs(color).toString(16).padStart(6, 0);
        }
      } else {
        color = "";
      }
      return color;
    },
    // 获取当天签到记录
    _getCurDateSignCardList() {
      getCurDateSignCardList({ empid: this.userInfo.empid }).then(res => {
        res.data.forEach(e => {
          if (e.signaddr.indexOf('@_@') > -1)
            e.signaddr =
              e.signaddr.split('@_@')[0] +
              (e.signaddr.split('@_@')[1]
                ? '(' + e.signaddr.split('@_@')[1] + ')'
                : '')
        })
        this.daylist = res.data
      })
    },
    // 签到描述按钮
    _GetFilterDropDownList() {
      GetFilterDropDownList({
        moduleno: '610',
        username: this.userInfo.username,
        listsql: '@签到按钮描述'
      }).then(res => {
        if (res.data.length > 0) {
          this.btnlist = res.data.map(e => {
            return {name:e.dicvalue,time:'',canclick:true,btncolor:null}
          })
        }
        // console.log(res)
      })
    },
    // 获取鉴权地址
    getmm() {
      let mm = window.location.href
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isiOS) {
        mm = window.globalurls
      }
      if (mm.indexOf('#') > -1) mm = mm.split('#')[0]
      return mm
    },
    // 钉钉jssdk鉴权
    dingdingConfig() {
      getDdSigurate({
        url: encodeURIComponent(this.getmm()),
        entid: localStorage.mulEntid
      }).then(res => {
        if (window.dev) {
          alert(JSON.stringify(res))
        }
        const j = {
          appId: res.agentId, // 必填，微应用ID
          agentId: res.agentId, // 必填，微应用ID
          corpId: res.corpId, //必填，企业ID
          timeStamp: res.sTimeStamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList: ['device.geolocation.get']
        }
        let _that = this
        dd.config(j)
        dd.ready(() => {
          if (window.dev) {
            alert('dd.ready')
          }
          dd.device.geolocation.get({
              targetAccuracy: 200,
              coordinate: 1,
              withReGeocode: true,
              useCache: true, //默认是true，如果需要频繁获取地理位置，请设置false
              onSuccess: result => {
                if (window.dev) {
                  alert(JSON.stringify(result))
                }
                _that.center = [result.longitude, result.latitude]
                _that.initAMap()
                if (window.dev) {
                  alert(_that.latitude)
                  alert(_that.longitude)
                }
              },
              onFail: err => {
                if (window.dev) {
                  alert(JSON.stringify(err))
                }
              }
            })
          setInterval(() => {
            dd.device.geolocation.get({
              targetAccuracy: 200,
              coordinate: 1,
              withReGeocode: true,
              useCache: true, //默认是true，如果需要频繁获取地理位置，请设置false
              onSuccess: result => {
                if (window.dev) {
                  alert(JSON.stringify(result))
                }
                _that.center = [result.longitude, result.latitude]
                _that.initAMap()
                if (window.dev) {
                  alert(_that.latitude)
                  alert(_that.longitude)
                }
              },
              onFail: err => {
                if (window.dev) {
                  alert(JSON.stringify(err))
                }
              }
            })
           }, 30000);
        })
        dd.error(error => {
          if (window.dev) {
            alert(
              JSON.stringify(error) + JSON.stringify(res) + window.globalurls
            )
          }
        })
      })
    },
    test(i) {
      alert(this.getmm())
      alert(window.location.href)
      if (i == 1) this.weixinConfig(this.getmm())
      if (i == 2) this.weixinConfig(encodeURIComponent(this.getmm()))
      if (i == 3)
        this.weixinConfig(encodeURIComponent(this.getmm().split('?')[0]))
      if (i == 4) this.weixinConfig(this.getmm().split('?')[0])
      if (i == 5) this.weixinConfig(window.location.href)
      if (i == 6) this.weixinConfig(encodeURIComponent(window.location.href))

      if (i == 7) {
        this.getCurrentLocation()
      }
    },
    getCurrentLocation() {
      var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 10000,
        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
        buttonOffset: new AMap.Pixel(10, 20),
        //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        zoomToAccuracy: true,
        //  定位按钮的排放位置,  RB表示右下
        buttonPosition: 'RB'
      })
      geolocation.getCurrentPosition((status, result) => {
        alert(status + JSON.stringify(result))
      })
    },
    // 获取微信 jssdk并且开放 getLocation
    weixinConfig(url) {
      // if(this.userInfo.username=='0010022') alert(url || this.getmm())
      let param = url || encodeURIComponent(this.getmm())
      if (window.fxdlReplace) {
        // 奔达由于做了反向代理，前端只能获取到https://192.168.7.33:8090/phonesign?from=home ，需要替换为 https://ehr.superband.com.cn:8090/phonesign?from=home
        const arr = window.fxdlReplace.split('|')
        param = param.replace(arr[0], arr[1])
      }
      GetJsSign({
        param: param
      }).then(res => {
        if (window.dev) {
          alert(JSON.stringify(res))
        }
        let _that = this
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ['getLocation']
        })

        wx.ready(function() {
          if (window.dev) {
            alert('wx.ready')
          }
          // if(_that.userInfo.username=='0010022') alert('wx.ready')
          // 7.2 获取当前地理位

setInterval(() => {
   wx.getLocation({
            type: 'gcj02',
            isHighAccuracy: true,
            highAccuracyExpireTime: 5000,
            // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            cache: false,
            success: function(res) {
              if (window.dev) {
                alert(JSON.stringify(res))
              }
              // if(_that.userInfo.username=='0010022') alert('success'+JSON.stringify(res))
              _that.center = [res.longitude, res.latitude]
              _that.initAMap()
            },
            cancel: function(res) {
              alert('cancel' + JSON.stringify(res))
            }
          })
}, 30000);

          wx.getLocation({
            type: 'gcj02',
            isHighAccuracy: true,
            highAccuracyExpireTime: 5000,
            // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            cache: false,
            success: function(res) {
              if (window.dev) {
                alert(JSON.stringify(res))
              }
              // if(_that.userInfo.username=='0010022') alert('success'+JSON.stringify(res))
              _that.center = [res.longitude, res.latitude]
              _that.initAMap()
            },
            cancel: function(res) {
              alert('cancel' + JSON.stringify(res))
            }
          })
          // wx.onLocationChange(function(res) {
          //   if (window.dev) {
          //     alert(JSON.stringify(res))
          //   }
            // if(res.errMsg == "auto:location:report:ok"){
            //   var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            //   var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            //   var speed = res.speed; // 速度，以米/每秒计
            //   var accuracy = res.accuracy; // 位置精度
            //   var lbsIndex = 0;
            // }else {
            //   //错误处理
            // }
          })
        // })
        wx.error(function(w) {
          if (window.dev) {
            alert('config error：' + JSON.stringify(w))
          }
          console.log('config error', w)
        })
      })
    },
    onClickLeft() {
      // if (this.$route.query.from == 'home') {
      //   this.$router.push('/home')
      // } else{
      //   this.$router.push('/personCen')
      // }
      this.$router.push('/home')
    },
    // 确认微调
    onConfirmwt(value) {
      this.address = value
      this.showwt = false
    },
    // 初始化地图
    initAMap(sign_type) {
      if (this.map_api_factory == 0) {
        window._AMapSecurityConfig = {
          securityJsCode: this.map_secret
        }
        AMapLoader.load({
          key: this.map_key, // 申请好的Web端开发者Key，首次调用 load 时必填
          version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: ['AMap.Geocoder', 'AMap.Geolocation'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
          .then(AMap => {
            //  if(this.userInfo.username=='0010022') alert('AMapLoader.load')
            this.map = new AMap.Map('phonesign_container', {
              // 设置地图容器id
              viewMode: '3D', // 是否为3D地图模式
              zoom: 15, // 初始化地图级别
              center: this.center // 初始化地图中心点位置
            })
            this.geocoder = new AMap.Geocoder({
              radius: 500, //以已知坐标为中心点，radius为半径，返回范围内兴趣点和道路信息
              extensions: 'all' //返回地址描述以及附近兴趣点和道路信息，默认“base”
            })
            if (sign_type == 2) {
              //参数说明：需要转换的坐标或者坐标组，需要转换的坐标类型，转换成功后的回调函数
              AMap.convertFrom(
                [this.$route.query.lng, this.$route.query.lat],
                'gps',
                (status, result) => {
                  //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                  //查询成功时，result.locations 即为转换后的高德坐标系
                  if (status === 'complete' && result.info === 'ok') {
                    var lnglats = result.locations //转换后的高德坐标 Array.<LngLat>
                    this.center = [lnglats[0].lng, lnglats[0].lat]
                    this.map.panTo(this.center)
                    this.setCenter(lnglats[0].lng, lnglats[0].lat)
                  }
                }
              )
            }
            this._getEmpSignPosition()
            // this.getCurrentLocation();
          })
          .catch(e => {
            console.log(e)
          })
      } else if (this.map_api_factory == 1) {
        this.xtdq(this.center[1], this.center[0])
      }
    },
    xtdq(lat, lng) {
      //星图地球
      // 创建XML请求
      var ajaxObj = new XMLHttpRequest()
      // 以get形式进行发送请求
      ajaxObj.open(
        'post',
        'https://api.open.geovisearth.com/address/v1/reverse_geocode?token='+this.map_key //'8b08dc2fb2d99355f713bb1662edf4a2'
      )
      ajaxObj.setRequestHeader('Content-Type', 'application/json')
      const data = JSON.stringify({
        points: lng + ',' + lat,
        radius: 10000,
        pagesize: 1,
        currentPage: 1
      })
      // 请求结束断开
      ajaxObj.send(data)
      // 初始化变量（必要）
      // 转入： this转为function（）方法内部函数（重点）
      const that = this
      ajaxObj.onreadystatechange = function() {
        if (ajaxObj.readyState === 4 && ajaxObj.status === 200) {
          // 请求放回的结果以文本形式，使用JSON.parse()方法进行转为json形式
          var data = JSON.parse(ajaxObj.responseText)
          // console.log('数据返回成功', ajaxObj.responseText)
          if (data.data.total > 0) {
            that.loading = false
            that.address =
              data.data.rows[0].name + '(' + data.data.rows[0].address + ')'
            that.pois = data.data.rows.map(e => {
              return e.name
            })
            // 没有设置签到范围
            if (that.posList.length == 0) that.cansign = true
            else {
              // 设置签到范围,循环判断是否在范围内
              that.posList.forEach(e => {
                console.log(e.wd, e.jd, lat, lng, '2222222222')

                if (GetDistance(e.wd, e.jd, lat, lng) <= e.radius) {
                  that.cansign = true
                  if (e.def_sign_place) that.address = e.def_sign_place
                }
              })
            }
          } else {
            Toast('根据经纬度查询地址失败')
          }
        }
      }
    },
    // 获取可以签到范围
    _getEmpSignPosition() {
      getEmpSignPosition({ empid: this.userInfo.empid }).then(res => {
        this.posList = res.data
        this.setCenter(this.center[0], this.center[1])
        this.posList.forEach(e => {
          // 构造矢量圆形
          var circle = new AMap.Circle({
            center: new AMap.LngLat(e.jd, e.wd), // 圆心位置
            radius: e.radius, //半径
            strokeColor: '#057de7', //线颜色
            strokeOpacity: 0.2, //线透明度
            strokeWeight: 2, //线粗细度
            fillColor: '#1791fc', //填充颜色
            fillOpacity: 0.35 //填充透明度
          })
          this.map.add(circle)
        })
      })
    },
    // 设置当前坐标
    setCenter(lng, lat) {
      if (this.marker) this.map.remove(this.marker)
      this.marker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: [lng, lat],
        anchor: 'bottom-center'
      })
      this.map.add(this.marker)
      this.cansign = false
      this.geocoder.getAddress([lng, lat], (status, result) => {
        // if(this.userInfo.username=='0010022') alert(' this.geocoder.getAddress'+JSON.stringify(result))
        if (status === 'complete' && result.regeocode) {
          this.loading = false
          this.address = result.regeocode.formattedAddress
          this.pois = [...result.regeocode.aois, ...result.regeocode.pois].map(
            e => {
              return e.name
            }
          )
          // 没有设置签到范围
          if (this.posList.length == 0) this.cansign = true
          else {
            // 设置签到范围,循环判断是否在范围内
            this.posList.forEach(e => {
              if (GetDistance(e.wd, e.jd, lat, lng) <= e.radius) {
                this.cansign = true
                if (e.def_sign_place) this.address = e.def_sign_place
              }
            })
          }
        } else {
          this.address = ''
          this.cansign = false
          Toast('根据经纬度查询地址失败')
        }
      })
    },
    // 点击【我要签到】
    clickSign() {
      if (this.needdailog||this.show_prj_when_sign) {
        this.daylist.forEach(e => {
            if(e.signflag&&e.showtime){
              this.btnlist.forEach(btn => {
                if(btn.name==e.signflag){
                  btn.time = e.hhmm.slice(0, 5);
                  btn.canclick = e.canclick;
                  btn.btncolor = e.btncolor;
                }
              });
            }
        });


        // 打开详细界面
        this.showdailog = true
      } else {
        if (this.needfile) {
          this.choosefile()
        } else {
          // 直接提交
          this.b4PostSign()
        }
      }
    },
    // 关闭签到详细
    confirm(action, done) {
      if (action == 'confirm') {
        if (!(this.content + this.choosbtn) && this.needdailog) {
          Toast('签到描述不能为空！')
          done(false)
          return
        }
        // if (!this.prjcode && this.show_prj_when_sign) {
        //   Toast('项目不能为空！')
        //   done(false)
        //   return
        // }
        if (this.needfile && this.fileList.length == 0) {
          Toast('请上传附件！')
          done(false)
          return
        }
        this.b4PostSign(done)
      } else {
        this.showdailog = false
        done()
      }
    },
    // 不显示详细界面时，触发附件上传
    choosefile() {
      if (this.fileList.length > 0) this.fileList = []
      this.$refs.uploader1.chooseFile()
    },
    // 上传附件后
    afterRead() {
      // alert(window.winCheckWifi)
      // 不显示详细界面时,直接提交
      this.b4PostSign(null)
    },
    // 提交前提醒
    b4PostSign(done) {
      if (window.winCheckWifi && sessionStorage.getItem('isOpenApp') == 1) {
        if (done) done()
        var data = {
          getWiFi: true
        }
        if (/android/i.test(navigator.userAgent)) {
          //这是Android平台下浏览器
          window.app.sendData(JSON.stringify(data))
        } else {
          uni.postMessage({
            data: data
          })
        }
        return
      } else {
        this._beforePostPhoneSignInfo(done)
      }
    },
    _beforePostPhoneSignInfo(done) {
      beforePostPhoneSignInfo({
        empid: this.userInfo.empid,
        signaddr: `${this.address}@_@${this.content +
          this.choosbtn}*_*${this.center.join(',')}*T*${parseTime(new Date())}`,
        wifi_name: this.newSSID || this.$route.query.ssid || '',
        wifi_ssid: this.newBSSID || this.$route.query.bssid || '',
        prjcode: this.prjcode
      }).then(async res => {
        if (res.data[0].isinfo && !res.data[0].cansave) {
          Notify({
            type: 'danger',
            message: res.data[0].info
          })
          if (done) done(false)
        } else if (res.data[0].isinfo && res.data[0].cansave) {
          const a = await this.ask(res.data[0].info)
          if (a) {
            this.PostSign(done)
          } else {
            if (done) done(false)
          }
        } else {
          this.PostSign(done)
        }
      })
    },
    // 提交签到
    PostSign(done) {
      const o = this.needfile
      this.needfile = false
      const obj = {
        empid: this.userInfo.empid,
        signaddr: `${this.address}@_@${this.content +
          this.choosbtn}*_*${this.center.join(',')}*T*${parseTime(new Date())}`,
        wifi_name: this.newSSID || this.$route.query.ssid || '',
        wifi_ssid: this.newBSSID || this.$route.query.bssid || '',
        prjcode: this.prjcode
      }
      savePhoneSignInfo(obj).then(res => {
        if (res && res.data && res.data[0].autoid && !res.data[0].info) {
          this._getCurDateSignCardList()
          if (this.fileList.length > 0) {
            upLoadFile({
              moduleno: '610',
              upflag: '2',
              autoid: res.data[0].autoid,
              uploadpath: 'AttachFile',
              username: this.userInfo.username,
              file: this.fileList[0].file
            }).then(res => {})
            // console.log(this.content, this.choosbtn, this.fileList)
          }

          if (done) done()
          if (this.sign_post_info) {
            Toast(this.sign_post_info)
          }
          this.fileList = []
          this.needfile = o
        } else {
          Notify({
            type: 'danger',
            message: res.data[0].info
          })
        }
      })
    },
    ask(msg) {
      // element弹窗
      return new Promise((resolve, reject) => {
        // this.$confirm(msg, '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // })
        Dialog.confirm({
          title: '系统提示',
          message: msg
        })
          .then(() => {
            resolve(true)
          })
          .catch(() => {
            resolve(false)
          })
      })
    },
    zj() {
      //足迹，跳转到刷卡记录
      this.$router.push({
        path: '/commHrQueryPage',
        query: {
          moduleno: 610,
          fromH5: true,
          fromPage: 'phonesign',
          ssid: this.$route.query.ssid,
          bssid: this.$route.query.bssid,
          lng: this.$route.query.lng,
          lat: this.$route.query.lat
        }
      })
    },
    // 打开不同意面试原因弹窗
    getprjPicker() {
      getSignPrjList({
        empid: this.userInfo.empid
      }).then(res => {
        this.prjList = res.data
        this.prjListPick = res.data.map(e => {
          return e.prjcode + '-' + e.prjname
        })
        this.showprjListPicker = true
      })
    },
    // 不同意面试原因弹窗回调
    onConfirmwprjLis(value, i) {
      this.prjcodeindex = i
      this.prjcode = this.prjList[i].prjcode
      this.prjname = this.prjList[i].prjname
      this.prjmemo = this.prjList[i].prjmemo
      this.prj_emplist = JSON.parse(this.prjList[i].prj_emplist)
      this.showprjListPicker = false
      this.prjList = []
      this.prjListPick = []
    },
    showPrjDetail() {
      if (this.prjcodeindex != null) this.showPrjDetailflag = true
    },
    setChoosbtn(item){
      if(item.canclick) this.choosbtn = item.name 
    }
  }
}
</script>
<style scoped lang="less">
.phonesign {
  .loading {
    position: absolute;
    padding-top: 75%;
    padding-left: 45%;
    z-index: 1111;
  }
  .van-nav-bar {
    background: #2b8df0;
    z-index: 99;
    /deep/.van-nav-bar__left,
    /deep/.van-nav-bar__right {
      .van-icon,
      .van-nav-bar__text {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .phonesignIndexBox {
    margin-top: 1.22667rem;
    background: #fff;
    height: calc(100vh - 1.22667rem);
    #phonesign_container {
      width: 100vw;
      height: 20vh;
    }
    .address-p {
      display: flex;
      justify-content: space-between;
       border-bottom: 5px solid #f0eff5;
      .address {
        padding: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 30px;
      }
      .van-button {
        width: 8em !important;
      }
    }
.sign_remark{padding:10px;font-weight: bold;}
    .signlist::-webkit-scrollbar {
      display: none;
    }
    .signlist {
     
      background: #fff;
      padding: 10px 30px 0;
      position: relative;
      overflow-y: scroll;
      height: 30vh;
      font-size: 20px;
      .signbox {
        border-left: 2px solid #f0eff5;
        padding-left: 10px;
        padding-bottom: 20px;
        display: flex;
        gap: 10px 10px;

        .signico {
          width: 4vw;
          height: 3.5vw;
          background-image: url('~@/assets/img/qrzq.png');
          background-size: 100% 100%;
        }
        .sigtadd {
          padding-left: 1em;
          background: url('~@/assets/img/sign.png') no-repeat;
          color: #5c5c5c;
          background-position-x: 0;
          background-position-y: 0.2em;
          background-size: 1em 1em;
        }
      }
    }
    .content {
      height: calc(100% - 50vh - 50px - 120px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .van-uploader {
        /deep/ .van-uploader__wrapper {
          .van-uploader__preview {
            display: none;
          }
        }
      }
      .check {
        font-size: 6vw;
        width: 20vw;
        height: 20vw;
      }
      .check.van-button--disabled {
        background: #999 !important;
      }
      .cks2 {
        font-size: 20px;
        padding-left: 1.2em;
        background: url('~@/assets/img/qrzq.png') left center no-repeat;
        background-size: 1em 1em;
        color: #e56e05;
      }
      .cks3 {
        font-size: 25px;
        color: #e50505;
        margin-top: 10px;
      }
    }
  }
  .signdetail {
    .van-dialog__content {
      .btnlist {
        display: flex;
        gap: 10px;
        justify-content: space-around;
        align-items: center;
        padding: 0 10px;
        .van-button {
          flex: 1;
        }
      }
    }
    .prjcodebox {
      padding: 0 10px 0 0;
      display: flex;
      gap: 10px;
      justify-content: space-around;
      align-items: center;
    }
  }
  .PrjDetail {
    .phonesignIndexBox {
      .van-collapse {
        /deep/ .van-collapse-item__title {
          font-weight: bold !important;
        }
        /deep/ .van-collapse-item__content {
          padding-top: 0;
          padding-bottom: 0;
          .van-cell {
            margin-bottom: 5px;
            background: #eee;
            .van-field__label {
              color: #666 !important;
            }
            .van-cell__value {
              color: #333 !important;
              .van-field__control:disabled {
                color: #333 !important;
                -webkit-text-fill-color: #333 !important;
              }
            }
          }
          .table {
            width: 100%;
            border-spacing: 0px;
            border-left: 1px solid #ccc;
            border-top: 1px solid #dcdfe6;
            tr {
              th,
              td {
                font-size: 28px;
                color:#333;
                padding: 20px 10px;
                text-align: center;
                border-bottom: 1px solid #dcdfe6;
                border-right: 1px solid #dcdfe6;
              
              }
              th{
                font-size: 26px;                
                background: #deefff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
